import { render, staticRenderFns } from "./Form2Layout.vue?vue&type=template&id=b3e2b20e&scoped=true"
import script from "./Form2Layout.vue?vue&type=script&lang=ts"
export * from "./Form2Layout.vue?vue&type=script&lang=ts"
import style0 from "@/styles/_pdf.scss?vue&type=style&index=0&id=b3e2b20e&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3e2b20e",
  null
  
)

export default component.exports